import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  fields: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '0.5rem',
    width: '100%',
    maxHeight: '175px',
    overflow: 'auto'
  },

  field: {
    cursor: 'pointer',
    marginBottom: '0.5rem',

    '&:last-child': {
      marginBottom: '0'
    }
  }
}))

export default useStyles
